var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import Modal from '../../../components/Modal';
import Select from '../../../elements/Select';
import ToggleSelect from '../../../elements/ToggleSelect';
import cxs from 'cxs/component';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { lang, T } from '../../../helpers/i18n';
export var ModalDestinationForm = function (props) {
    var countries = props.countries, hide = props.hide;
    var DefaultCountry = 'Spain';
    var _a = React.useState(DefaultCountry), countrySelected = _a[0], setCountrySelected = _a[1];
    var _b = React.useState([]), states = _b[0], setStates = _b[1];
    var _c = React.useState([]), allStatesOptions = _c[0], setAllStatesOptions = _c[1];
    var _d = React.useState(null), filteredOption = _d[0], setFilteredOption = _d[1];
    var _e = React.useState([]), cities = _e[0], setCities = _e[1];
    var _f = React.useState([]), citiesSelected = _f[0], setCitiesSelected = _f[1];
    var countryOptions = countries.map(function (country) { return ({
        name: country.translations[lang] || country.name,
        value: country.name
    }); }).sort(function (a, b) { return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }); });
    var cityOptions = __spreadArray([{ name: 'Seleccione ciudad', value: 0 }], cities.map(function (city) { return ({
        name: city.name,
        value: city.id
    }); }), true);
    var citiesSelectedOption = citiesSelected.map(function (citySelected) { return ({
        name: citySelected.name,
        value: citySelected.id
    }); });
    // actualizo `states` cuando cambia el país seleccionado
    useEffect(function () {
        var _a;
        var country = countries.find(function (c) { return c.name === countrySelected; });
        var filterCallback = function (s) { return s.type === 'province' || s.type === 'region' || s.type === 'state' || s.type === 'land'; };
        var _states = ((_a = country === null || country === void 0 ? void 0 : country.states) === null || _a === void 0 ? void 0 : _a.filter(filterCallback).filter(function (s) { var _a; return ((_a = s.cities) === null || _a === void 0 ? void 0 : _a.length) > 0; }).sort(function (a, b) {
            return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' });
        })) || [];
        setStates(_states);
        setFilteredOption(null);
        setCities([]);
        // es necesario resetear las ciudades??
        // setCitiesSelected([])
    }, [countrySelected, countries]);
    useEffect(function () {
        var initialStatesOptions = states.map(function (s) { return ({
            id: s.id,
            name: s.name,
            value: s.id,
            selected: false // me aseguro que está sin seleccionar
        }); });
        setAllStatesOptions(initialStatesOptions);
    }, [states]);
    useEffect(function () {
    }, [citiesSelected]);
    var handleChangeSelect = function (e) {
        setCountrySelected(e.target.value);
    };
    var handleCityChangeSelect = function (e) {
        var cityClicked = cities.find(function (c) { return c.id === Number(e.target.value); });
        console.log('cityClicked: ', cityClicked);
        console.log('e: ', e.target.value);
        // verifico que cityClicked existe antes de proceder
        if (!cityClicked)
            return;
        var updateCitiesSelected = cloneDeep(citiesSelected);
        if (!updateCitiesSelected.find(function (city) { return city.id === cityClicked.id; })) {
            // no está, la agrego
            updateCitiesSelected.push(cityClicked);
        }
        else {
            // está, la elimino
            var index = updateCitiesSelected.findIndex(function (city) { return city.id === cityClicked.id; });
            updateCitiesSelected.splice(index, 1);
        }
        setCitiesSelected(updateCitiesSelected);
    };
    var handleToggleSelect = function (event) {
        var _a;
        var clicked = event.target.options.find(function (option) { return option.selected; });
        var clickedValue = clicked === null || clicked === void 0 ? void 0 : clicked.value;
        var updatedOptions = allStatesOptions.map(function (opt) {
            if (opt.value === clickedValue) {
                return __assign(__assign({}, opt), { selected: !opt.selected });
            }
            else {
                return __assign(__assign({}, opt), { selected: false });
            }
        });
        var isNowSelected = (_a = updatedOptions.find(function (opt) { return opt.value === clickedValue; })) === null || _a === void 0 ? void 0 : _a.selected;
        if (isNowSelected) {
            setFilteredOption(updatedOptions.find(function (opt) { return opt.value === clickedValue; }) || null);
            var stateClicked = states.find(function (state) { return state.id === clickedValue; });
            setCities((stateClicked === null || stateClicked === void 0 ? void 0 : stateClicked.cities.sort(function (a, b) { return a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }); })) || []);
        }
        else {
            setFilteredOption(null);
            setCities([]);
        }
        setAllStatesOptions(updatedOptions);
    };
    return (React.createElement(Modal, { style: { width: '100%', height: '100%' }, title: 'Destinations', hide: hide },
        React.createElement("div", { style: { margin: '25px' } },
            React.createElement("label", null, 'Selecciona el país'),
            React.createElement(Select, { options: countryOptions, value: countrySelected, onChange: handleChangeSelect }),
            React.createElement("label", null, 'Selecciona Provincia'),
            React.createElement(ToggleSelect, { multiple: false, onChange: handleToggleSelect, options: allStatesOptions, itemChild: function (item, toggleSelectClickHandler) {
                    var isVisible = !filteredOption || item.value === filteredOption.value;
                    if (!isVisible)
                        return null;
                    return (React.createElement(ItemWrapper, { key: "ts_item_wrapper_".concat(item.id || item.value), extractKey: "".concat(item.name, "_").concat(item.id || item.value), selected: !!item.selected, disabled: !!item.disabled, onClick: function () { return toggleSelectClickHandler(item); } }, item.name));
                } }),
            citiesSelected && citiesSelected.length > 0 &&
                React.createElement(React.Fragment, null,
                    React.createElement("label", null, 'Ciudades seleccionadas'),
                    React.createElement(ToggleSelect, { options: citiesSelectedOption, onChange: function (e) {
                            console.log('onChange - e: ', e);
                            var updateCitiesSelected = cloneDeep(citiesSelected);
                            var clicked = e.target.options.find(function (to) { return to.selected; });
                            console.log('clicked: ', clicked);
                            if (clicked) {
                                var index = updateCitiesSelected.findIndex(function (uc) { return uc.id === clicked.value; });
                                if (index !== -1) {
                                    updateCitiesSelected.splice(index, 1);
                                    setCitiesSelected(updateCitiesSelected);
                                }
                            }
                        }, multiple: false })),
            states && states.length > 0 &&
                React.createElement(React.Fragment, null,
                    React.createElement("label", null, 'Selecciona ciudad'),
                    React.createElement(Select, { options: cityOptions, value: citiesSelected, onChange: handleCityChangeSelect }))),
        React.createElement(ButtonsBar, null,
            React.createElement(StyledButton, { primary: true, onClick: function () {
                    if (props.onClickCancel) {
                        props.onClickCancel();
                    }
                } }, T('cancel')),
            React.createElement(StyledButton, { primary: true, onClick: function () {
                    if (props.onClickSave) {
                        props.onClickSave(citiesSelected);
                    }
                } }, T('save')))));
};
var ItemWrapper = cxs('div')(function (_a) {
    var selected = _a.selected;
    return (__assign(__assign({ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '10px', margin: '5px', border: '1px solid lightgray' }, (selected
        ? {
            borderColor: 'green',
            color: 'white',
            backgroundColor: 'green'
        }
        : undefined)), { borderRadius: '10px', cursor: 'pointer' }));
});
ItemWrapper.propTypes = {
    selected: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Destinations/containers/ModalDestinationForm.tsx
// module id = 1606
// module chunks = 0